import createIcon from "./createIcon";

export const WordIcon = createIcon('Word', (props) => {
  return (
    <svg {...props} viewBox="0 0 16 16">
      <rect id="Word" width="16.000000" height="16.000000" x="0.000000" y="0.000244" />
      <g>
        <path d="M1.5 0.00012207L10.4995 0.00012207L15.5 5.00005L15.5 15.0001C15.5 15.5524 15.0523 16.0001 14.5 16.0001L1.5 16.0001C0.947715 16.0001 0.5 15.5524 0.5 15.0001L0.5 1.00012C0.5 0.447837 0.947715 0.00012207 1.5 0.00012207Z" fill="rgb(65,156,248)" fillRule="evenodd" />
        <path id="矢量 118" d="M10.5001 4.00005L10.5 0L15.5001 5L11.5001 5.00005C10.9478 5.00005 10.5001 4.55233 10.5001 4.00005Z" fill="rgb(108,189,255)" fillRule="evenodd" />
        <g>
          <path d="M6.54387 13.0363L4.98217 13.0363L3.25586 6.54053L4.84968 6.54053L5.88547 10.8563L5.93565 10.8563L7.13604 6.54053L8.78004 6.54053L10.0627 10.8563L10.1129 10.8563L11.1487 6.54053L12.7445 6.54053L10.9339 13.0363L9.37221 13.0363L7.98313 8.76867L7.93295 8.76867L6.54387 13.0363Z" fill="rgb(255,255,255)" fillRule="evenodd" />
        </g>
      </g>
    </svg >
  )
});
